import styled from 'styled-components';
import { StyledInputProps } from './types';

export const Input = styled.input<StyledInputProps>`
  width: 56px;
  height: 56px;
  margin-right: ${({ theme }) => theme.spacing.km4};
  font-size: ${({ theme }) => theme.font.size.m7};
  color: ${({ theme }) => theme.color.text.neutral.default};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  border-radius: ${({ theme }) => theme.border.radius.small};
  text-align: center;
  border: 1.5px solid ${({ theme }) => theme.color.border.neutral.default};
  box-shadow: 0px 6px 12px -6px rgba(38, 47, 74, 0.12),
    0px 8px 24px -4px rgba(38, 47, 74, 0.08);

  &:focus {
    outline: ${({ theme }) => theme.spacing.km0};
    border-radius: ${({ theme }) => theme.border.radius.small};
  }

  border: ${({ $error, theme }) =>
    $error
      ? `1.5px ${theme.border.style.solid} ${theme.color.border.danger.default}`
      : theme.spacing.km0};
`;
